// extracted by mini-css-extract-plugin
module.exports = {"tabNav":"SiteDashboardControlsTabs_tabNav__2Wnib","active":"SiteDashboardControlsTabs_active__VGIMf"};